
// let baseUrl = "http://47.102.156.208:8994/";  // 开发服务器
let baseUrl = "https://admin.wxzxwh.cn/";  // 生产服务器

// let baseUrl = "/"; // 生产
  
//接口
const ApiUrls = {
	webUrl:baseUrl,
	//普通登录接口
	LoginUrl: baseUrl + 'api/CISToken/Generator',//获取token
	//获取用户列表
	GetUserList:baseUrl+'api/services/app/CZPTUser/UserList',
	//用户信息
	GetUserInfo:baseUrl+'api/services/app/CZPTUser/UserInfo',
	//更新信息
	UserUpdate:baseUrl+'api/services/app/CZPTUser/UserUpdate',
	UserInsert:baseUrl+'api/services/app/CZPTUser/UserInsert',

	// 用户信息
	UserInfoForUser:baseUrl+'api/services/app/CZPTUser/UserInfoForUser',
	// 禁用(超管)
	UserDisable:baseUrl+'api/services/app/CZPTUser/UserDisabl',
	// 激活(超管)
	UserActive:baseUrl+'api/services/app/CZPTUser/UserActive',
	//重置密码
	PasswordReset:baseUrl+'api/services/app/CZPTUser/PasswordReset',
	// 修改密码
	PasswordEdit:baseUrl+'api/services/app/CZPTUser/PasswordEdit',
	// 新增部门
	DeptInsert:baseUrl+'api/services/app/CZPTDept/DeptInsert',
	// 部门信息
	DeptInfo:baseUrl+'api/services/app/CZPTDept/DeptInfo',
	// 更新部门
	DeptUpdate:baseUrl+'api/services/app/CZPTDept/DeptUpdate',
	// 删除部门
	DeptRemove:baseUrl+'api/services/app/CZPTDept/DeptRemove',
	// 部门列表(管理部门树，显示完整的数据)
	DeptList:baseUrl+'api/services/app/CZPTDept/DeptList',
	// 获取部门序列
	DeptSeq:baseUrl+'api/services/app/CZPTDept/DeptSeq',

	RoleInfo:baseUrl+'api/services/app/CZPTRole/RoleInfo',
	RoleTree:baseUrl+'api/services/app/CZPTRole/RoleTree',
	RoleInsert:baseUrl+'api/services/app/CZPTRole/RoleInsert',
	RoleUpdate:baseUrl+'api/services/app/CZPTRole/RoleUpdate',
	RoleRemove:baseUrl+'api/services/app/CZPTRole/RoleRemove',
	// 部门员工
	DeptUserListGet:baseUrl+'api/services/app/CZPTDeptUser/UserListGet',
	// 部门员工绑定
	DeptUserBind:baseUrl+'api/services/app/CZPTDeptUser/DeptUsersBind',
	// 角色列表
	DeptRoleUserListGet:baseUrl+'api/services/app/CZPTRoleUser/UserListGet',
	// 角色员工绑定
	DeptRoleUserBind:baseUrl+'api/services/app/CZPTRoleUser/DeptUsersBind',

	// 产品列表
	ProductList:baseUrl+'api/services/app/CZPTProduct/ProductList',
	// 产品信息
	ProductInfo:baseUrl+'api/services/app/CZPTProduct/ProductInfo',
	// 产品新增
	ProductInsert:baseUrl+'api/services/app/CZPTProduct/ProductInsert',
	// 产品修改
	ProductUpdate:baseUrl+'api/services/app/CZPTProduct/ProductUpdate',
	// 产品删除
	ProductRemove:baseUrl+'api/services/app/CZPTProduct/ProductRemove',

	// 支付通道列表
	PaymentList:baseUrl+'api/services/app/CZPTPayment/PaymentList',
	// 支付通道信息
	PaymentInfo:baseUrl+'api/services/app/CZPTPayment/PaymentInfo',
	// 支付通道新增
	PaymentInsert:baseUrl+'api/services/app/CZPTPayment/PaymentInsert',
	// 支付通道修改
	PaymentUpdate:baseUrl+'api/services/app/CZPTPayment/PaymentUpdate',
	// 支付通道删除
	PaymentRemove:baseUrl+'api/services/app/CZPTPayment/PaymentRemove',

	// 资源导入
	CustomersImport:baseUrl+'api/services/app/CZPTCustomer/CustomersImport',
	// 资源模板下载
	CustomersDownloadTemplate:baseUrl+'api/services/app/CZPTCustomer/CustomersDownloadTemplate',
	// 资源新增
	CustomersInsert:baseUrl+'api/services/app/CZPTCustomer/CustomersInsert',
	// 资源修改
	CustomersUpdate:baseUrl+'api/services/app/CZPTCustomer/CustomersUpdate',
	// 资源删除
	CustomersRemove:baseUrl+'api/services/app/CZPTCustomer/CustomersRemove',
	// 资源列表
	CustomersList:baseUrl+'api/services/app/CZPTCustomer/CustomersList',
	// 资源信息
	CustomersInfo:baseUrl+'api/services/app/CZPTCustomer/CustomersInfo',
	// 我的客户信息列表
	CustomersToUserList:baseUrl+'api/services/app/CZPTCustomer/CustomersToUserList',
	
	// 资源新增
	CustomersToUserInsert:baseUrl+'api/services/app/CZPTCustomer/CustomersToUserInsert',
	// 资源修改
	CustomersToUserUpdate:baseUrl+'api/services/app/CZPTCustomer/CustomersToUserUpdate',
	// 资源删除
	CustomersToUserRemove:baseUrl+'api/services/app/CZPTCustomer/CustomersToUserRemove',

	// 分配员工
	CustomersToSale:baseUrl+'api/services/app/CZPTCustomer/CustomersToSale',
	// 批量分配员工
	CustomersAllocateUsers:baseUrl+'api/services/app/CZPTCustomer/CustomersAllocateUsers',

	// 菜单
	MenuTree:baseUrl+'api/services/app/CZPTMenu/MenuTree',
	// 菜单信息
	MenuInfo:baseUrl+'api/services/app/CZPTMenu/MenuInfo',
	// 菜单新增
	MenuInsert:baseUrl+'api/services/app/CZPTMenu/MenuInsert',
	// 菜单修改
	MenuUpdate:baseUrl+'api/services/app/CZPTMenu/MenuUpdate',
	// 菜单删除
	MenuRemove:baseUrl+'api/services/app/CZPTMenu/MenuRemove',
	// 菜单树
	RoleMenusTree:baseUrl+'api/services/app/CZPTRolesMenu/RoleMenusTree',
	// 菜单权限绑定
	RoleMenusBind:baseUrl+'api/services/app/CZPTRolesMenu/RoleMenusBind',
	// 菜单权限列表
	UserInMenu:baseUrl+'api/services/app/CZPTRolesMenu/UserInMenu',

	// 字典列表
	SysDictList:baseUrl+'api/services/app/CZPTSysDict/SysDictList',
	// 字典信息
	SysDictInfo:baseUrl+'api/services/app/CZPTSysDict/SysDictInfo',
	// 字典新增
	SysDictInsert:baseUrl+'api/services/app/CZPTSysDict/SysDictInsert',
	// 字典修改
	SysDictUpdate:baseUrl+'api/services/app/CZPTSysDict/SysDictUpdate',
	// 字典删除
	SysDictRemove:baseUrl+'api/services/app/CZPTSysDict/SysDictRemove',
	// 字典下拉
	SysDictListSelect:baseUrl+'api/services/app/CZPTSysDict/SysDictListSelect',
	// 字典禁用
	SysDictPause:baseUrl+'api/services/app/CZPTSysDict/SysDictPause',
	// 字典启用
	SysDictResume:baseUrl+'api/services/app/CZPTSysDict/SysDictResume',
	
	// 订单新增
	CustomerOrderInsert:baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderInsert',
	// 订单修改
	CustomerOrderUpdate:baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderUpdate',
	// 订单删除
	CustomerOrderRemove:baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderRemove',
	// 订单列表
	CustomerOrderList:baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderList',
	// 订单信息
	CustomerOrderInfo:baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderInfo',
	// 订单客户产品列表
	CustomerOrderProductList: baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderProductList',

	// 订单客户产品记录集支付信息列表
	CustomerOrderProductDetailAndPaymentList: baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailAndPaymentList',
	// 添加客户订单产品
	CustomerOrderProductDetailInsert:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailInsert',
	// 订单产品列表
	CustomerOrderProductDetailList:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailList',
	// 订单产品删除
	CustomerOrderProductDetailRemove:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailRemove',	
	// 订单产品信息
	CustomerOrderProductDetailInfo:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailInfo',
	// 订单产品修改
	CustomerOrderProductDetailUpdate:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailUpdate',
	// 订单日志
	CustomerOrderChange:baseUrl+'api/services/app/CZPTCustomerOrder/CustomerOrderChangeLog',

	// 审批同意
	CustomerOrderProductApproval:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailApproval',
	// 审批撤回
	CustomerOrderProductWithDraw:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailWithDraw',
	// 审批信息
	CustomerOrderProductApprovalInfo:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailApprovalInfo',
	// 近12个月新单统计
	Last12MonthsSalesData:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/Last12MonthsSalesData',
	// 近12个月升级单统计
	Last12MonthsSalesDataUp:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/Last12MonthsSalesDataUp',
	DepartmentTreeWithUserCountAndUsers:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/DepartmentTreeWithUserCountAndUsers',
	DepartmentTreeWithUserCountAndUsersUp:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/DepartmentTreeWithUserCountAndUsersUp',


	// 添加客户订单产品支付信息
	CustomerOrderProductPaymentDetailInsert:baseUrl+'api/services/app/CZPTCustomerOrderProductPaymentDetail/CustomerOrderProductPaymentDetailInsert',
	// 订单产品支付信息列表
	CustomerOrderProductPaymentDetailList:baseUrl+'api/services/app/CZPTCustomerOrderProductPaymentDetail/CustomerOrderProductPaymentDetailList',
	// 订单产品支付信息删除
	CustomerOrderProductPaymentDetailRemove:baseUrl+'api/services/app/CZPTCustomerOrderProductPaymentDetail/CustomerOrderProductPaymentDetailRemove',
	// 订单产品支付信息信息
	CustomerOrderProductPaymentDetailInfo:baseUrl+'api/services/app/CZPTCustomerOrderProductPaymentDetail/CustomerOrderProductPaymentDetailInfo',
	// 订单产品支付信息修改
	CustomerOrderProductPaymentDetailUpdate:baseUrl+'api/services/app/CZPTCustomerOrderProductPaymentDetail/CustomerOrderProductPaymentDetailUpdate',

	// 添加客户订单退款
	CustomerOrderRefundInsert:baseUrl+'api/services/app/CZPTCustomerOrderRefundRecord/CustomerOrderRefundRecordInsert',
	// 订单退款列表
	CustomerOrderRefundDetailList:baseUrl+'api/services/app/CZPTCustomerOrderRefundRecord/CustomerOrderRefundRecordList',
	// 订单退款删除
	CustomerOrderRefundDetailRemove:baseUrl+'api/services/app/CZPTCustomerOrderRefundRecord/CustomerOrderRefundRecordRemove',
	// 订单退款信息
	CustomerOrderRefundDetailInfo:baseUrl+'api/services/app/CZPTCustomerOrderRefundRecord/CustomerOrderRefundRecordInfo',

	// 添加客户订单联系备注
	CustomerOrderContactRemarkDetailInsert:baseUrl+'api/services/app/CZPTCustomerOrderContactRemarkDetail/CustomerOrderContactRemarkDetailInsert',
	// 订单联系备注列表
	CustomerOrderContactRemarkDetailList:baseUrl+'api/services/app/CZPTCustomerOrderContactRemarkDetail/CustomerOrderContactRemarkDetailList',
	// 订单联系备注删除
	CustomerOrderContactRemarkDetailRemove:baseUrl+'api/services/app/CZPTCustomerOrderContactRemarkDetail/CustomerOrderContactRemarkDetailRemove',
	// 订单联系备注信息
	CustomerOrderContactRemarkDetailInfo:baseUrl+'api/services/app/CZPTCustomerOrderContactRemarkDetail/CustomerOrderContactRemarkDetailInfo',
	// 订单联系备注修改
	CustomerOrderContactRemarkDetailUpdate:baseUrl+'api/services/app/CZPTCustomerOrderContactRemarkDetail/CustomerOrderContactRemarkDetailUpdate',
	
	// 添加客户持仓
	CustomerOrderPositionRecordInsert:baseUrl+'api/services/app/CZPTCustomerOrderPositionRecord/CustomerOrderPositionRecordInsert',
	// 客户持仓列表
	CustomerOrderPositionRecordList:baseUrl+'api/services/app/CZPTCustomerOrderPositionRecord/CustomerOrderPositionRecordList',
	// 客户持仓删除
	CustomerOrderPositionRecordRemove:baseUrl+'api/services/app/CZPTCustomerOrderPositionRecord/CustomerOrderPositionRecordRemove',
	// 客户持仓信息
	CustomerOrderPositionRecordInfo:baseUrl+'api/services/app/CZPTCustomerOrderPositionRecord/CustomerOrderPositionRecordInfo',
	// 客户持仓修改
	CustomerOrderPositionRecordUpdate:baseUrl+'api/services/app/CZPTCustomerOrderPositionRecord/CustomerOrderPositionRecordUpdate',
	// 批量更改卖出价格
	CustomerOrderPositionRecordUpdateList:baseUrl+'api/services/app/CZPTCustomerOrderPositionRecord/CustomerOrderPositionRecordUpdateList',

	// 首页统计
	CustomerOrderSaleSum:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderSaleSum',
	// 订单产品分配
	CustomerOrderProductDetailToUser:baseUrl+'api/services/app/CZPTCustomerOrderProductDetail/CustomerOrderProductDetailToUser',

	// 上传资源
	UploadFiles:baseUrl+'api/services/app/CZPTUploads/UploadFiles',



	


	ChangePassWord:baseUrl+'api/Login/ChangePassWord',
	//获取用户权限
	GetUserPermission:baseUrl+'api/services/app/CZUser/UserInfoForUser',
	
	
	Logout:baseUrl+'api/services/app/CZUser/logout',
	RoleList:baseUrl+'api/services/app/CZRole/RoleList',
	UserListGet:baseUrl+'api/services/app/CZRoleUser/UserListGet',
	RoleUserBind:baseUrl+'api/services/app/CZRoleUser/RoleUsersBind',
	RoleUserRemove:baseUrl+'api/services/app/CZRoleUser/RoleUserRemove',
	//项目详情
	ProjectInfo:baseUrl+'api/services/app/CZProject/ProjectInfo',
	//项目 更新
	ProjectUpdate:baseUrl+'api/services/app/CZProject/ProjectUpdate',
	//项目删除
	ProjectRemove:baseUrl+'api/services/app/CZProject/ProjectRemove',
	//项目树
	ProjectTree:baseUrl+'api/services/app/CZProject/ProjectTree',
	//项目排序
	ProjectSeq:baseUrl+'api/services/app/CZProject/ProjectSeq',
	//项目新增
	ProjectInsert:baseUrl+'api/services/app/CZProject/ProjectInsert',
	//项目详情列表
	ProjectDetailList:baseUrl+'api/services/app/CZProjectDetail/ProjectDetailList',
	//项目数据
	ProjectDetailInfo:baseUrl+'api/services/app/CZProjectDetail/ProjectDetailInfo',
	//项目详情新增
	ProjectDetailInsert:baseUrl+'api/services/app/CZProjectDetail/ProjectDetailInsert',
	//项目详情修改
	ProjectDetailUpdate:baseUrl+'api/services/app/CZProjectDetail/ProjectDetailUpdate',
	//项目详情删除
	ProjectDetailRemove:baseUrl+'api/services/app/CZProjectDetail/ProjectDetailRemove',
	
	//模板树，带三级
	ProjectTreeDetail:baseUrl+'api/services/app/CZProject/ProjectTreeDetail',
	//合同列表
	ContractList:baseUrl+'api/services/app/CZContract/ContractList',
	//合同主表记录
	// ContractInfo:baseUrl+'api/services/app/CZContract/ContractInfo',// 废弃，接口太慢
	ContractInfo:baseUrl+'api/services/app/CZContract/ContractVisitorInfo',
	
	//合同-关联用户（分配）
	ContractUserBind:baseUrl+'api/services/app/CZContractUser/ContractUserBind',
	//合同签订
	ContractOk:baseUrl+'api/services/app/CZContract/ContractOk',
	//合同导出pdf
	ContractToPdf:baseUrl+'api/services/app/CZContract/ContractToPdf',

	//合同其他信息
	DictionaryList:baseUrl+'api/services/app/CZDictionary/DictionaryList',
	//合同其他信息详情
	DictionaryInfo:baseUrl+'api/services/app/CZDictionary/DictionaryInfo',
	//合同其他信息详情
	DictionaryInSert:baseUrl+'api/services/app/CZDictionary/DictionaryInSert',
	//合同其他信息详情
	DictionaryUpdate:baseUrl+'api/services/app/CZDictionary/DictionaryUpdate',
	//合同其他信息详情
	DictionaryRemove:baseUrl+'api/services/app/CZDictionary/DictionaryRemove',

	//合同分配人员
	ContractUser:baseUrl+'api/services/app/CZContractUser/UserListGet',
	//合同解除分配
	ContractUserRemove:baseUrl+'api/services/app/CZContractUser/ContractUserRemove',

	PictureTypeList:baseUrl+'api/services/app/CZPictureType/PictureTypeList',
	PictureTypeInsert:baseUrl+'api/services/app/CZPictureType/PictureTypeInsert',
	PictureTypeUpdate:baseUrl+'api/services/app/CZPictureType/PictureTypeUpdate',
	PictureTypeRemove:baseUrl+'api/services/app/CZPictureType/PictureTypeRemove',
	PictureList:baseUrl+'api/services/app/CZPicture/PictureList',
	PictureUpdate:baseUrl+'api/services/app/CZPicture/PictureUpdate',
	PictureInsert:baseUrl+'api/services/app/CZPicture/PictureInsert',
	PictureRemove:baseUrl+'api/services/app/CZPicture/PictureRemove',

	

	//排版
	ContractScheduling:baseUrl+'api/services/app/CZContract/ContractScheduling',
	//排版列表
	ContractScheduMainList:baseUrl+'api/services/app/CZContract/ContractScheduMainList',
	//排版详情
	ContractScheduMainInfo:baseUrl+'api/services/app/CZContract/ContractScheduMainInfo',
	//排版删除
	ContractSchedulingDel:baseUrl+'api/services/app/CZContract/ContractSchedulingDel',
	//排版日历
	ContractScheduList:baseUrl+'api/services/app/CZContract/ContractScheduList',
	
}

export default ApiUrls
